// Package imports:
import React from 'react';
// Component imports:
import Tabs from '../../ui-elements/Tabs/Tabs';
import VehicleSearch from './VehicleSearch/VehicleSearch';
import ConstructionsSearch from './ConstructionsSearch/ConstructionsSearch';
import SsnSearch from './SsnSearch/SsnSearch';
import HistorySearch from './HistorySearch/HistorySearch';
import HistoryButtonDropDown from '../HistoryButtonDropDown/HistoryButtonDropDown';
import HeadSection from '../../ui-elements/HeadSection/HeadSection';
// Type imports:

interface IProps {
    bondsAllowed: boolean,
    individualAssetsAllowed: boolean
}

const Okutaeki: React.FC<IProps> = ({
    bondsAllowed,
    individualAssetsAllowed
}) => {
    return (
        <div className="main KCL_Okutaeki">
            <div className='section__body'>
                <div className='shell'>
                    <HeadSection
                        title={
                            <>
                                <h1>Ökutæki</h1>
                                <HistoryButtonDropDown />
                            </>
                        }
                    />
                    <Tabs  
                        tabsSize="lg"
                        saveTabToUrl
                        tabs={[{
                            id: "Okutaekjaskra",
                            label: "Ökutækjaskrá",
                            component: <VehicleSearch bondsAllowed={bondsAllowed} />
                        }, {
                            id: "Vinnuvelaskra",
                            label:"Vinnuvélaskrá",
                            component: <ConstructionsSearch />
                        }, {
                            id: "Eignastada",
                            label:"Eignastaða",
                            component: <SsnSearch individualAssetsAllowed={individualAssetsAllowed} />
                        }, {
                            id: "Ferilskra",
                            label:"Ferilskrá",
                            component: <HistorySearch />
                        }]}
                    />
                </div>
            </div>
        </div>
    )
}

export default Okutaeki;